"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FavoritesService = exports.FavoritesServiceProductOrganization = exports.FavoritesServiceError = void 0;
const yup_1 = require("yup");
class FavoritesServiceError extends Error {
    constructor(message) {
        super(message);
        this.name = 'FavoritesServiceError';
        Object.setPrototypeOf(this, FavoritesServiceError.prototype);
    }
}
exports.FavoritesServiceError = FavoritesServiceError;
const FavoritesServiceResponseDtoSchema = (0, yup_1.object)({
    skus: (0, yup_1.array)((0, yup_1.string)().required()).required(),
});
var FavoritesServiceProductOrganization;
(function (FavoritesServiceProductOrganization) {
    FavoritesServiceProductOrganization["Boticario"] = "boticario";
    FavoritesServiceProductOrganization["Eudora"] = "eudora";
    FavoritesServiceProductOrganization["Oui"] = "oui";
    FavoritesServiceProductOrganization["EuAmoMake"] = "qdb";
})(FavoritesServiceProductOrganization = exports.FavoritesServiceProductOrganization || (exports.FavoritesServiceProductOrganization = {}));
class FavoritesService {
    constructor(tdcClient) {
        this.tdcClient = tdcClient;
    }
    getFavorites(params) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { businessUnit, customerId, listName, resellerSlug } = params;
                const response = yield this.tdcClient.get(`/favorites/${customerId}/`, {
                    params: {
                        businessUnit,
                        listName,
                        resellerSlug,
                    },
                });
                this.validateResponse(response.data);
                return response.data;
            }
            catch (error) {
                throw new FavoritesServiceError('Failed to get favorites');
            }
        });
    }
    addFavorites(params) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { businessUnit, customerId, listName, products, resellerSlug } = params;
                const body = {
                    resellerSlug,
                    listName,
                    products: products.map(({ sku, organization }) => ({
                        sku,
                        organization,
                    })),
                };
                const response = yield this.tdcClient.post(`/favorites/${customerId}/`, body, {
                    params: {
                        businessUnit,
                    },
                });
                this.validateResponse(response.data);
                return response.data;
            }
            catch (error) {
                throw new FavoritesServiceError('Failed to add favorite');
            }
        });
    }
    removeFavorite(params) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { businessUnit, customerId, listName, resellerSlug, productOrganization, sku } = params;
                const response = yield this.tdcClient.delete(`/favorites/${customerId}`, {
                    params: {
                        businessUnit,
                        listName,
                        productOrganization,
                        resellerSlug,
                        sku,
                    },
                });
                this.validateResponse(response.data);
                return response.data;
            }
            catch (error) {
                throw new FavoritesServiceError('Failed to remove favorite');
            }
        });
    }
    validateResponse(response) {
        if (!FavoritesServiceResponseDtoSchema.isValidSync(response)) {
            throw new FavoritesServiceError('Invalid response from favorites service');
        }
        return true;
    }
}
exports.FavoritesService = FavoritesService;
